import { createSlice } from "@reduxjs/toolkit";
import { getChefVerifiedAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getChefVerifiedSlice = createSlice({
  name: "getChefVerified",
  initialState: data,
  reducers: {
   getChefVerifiedSlice(state) {
      state.isLoading = true;
    },
   getChefVerifiedSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefVerifiedSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getChefVerifiedSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getChefVerifiedHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(getChefVerifiedAction.getChefVerifiedSlice());
    const response: any = await getChefVerifiedAPI(data);
    
    dispatch(getChefVerifiedAction.getChefVerifiedSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefVerifiedAction.getChefVerifiedSliceFailure(e?.response?.data));
  }
};
export default getChefVerifiedSlice.reducer;
export const getChefVerifiedAction = getChefVerifiedSlice.actions;
